import React, { useState } from 'react';
import { C } from '../theme';
import { Card, CardTitle, RCard, QuoteBox, FinInput, BtnPrimary, Badge } from '../components/Card';
import { JMML, ROOT_DATA, calcRoot, reduceNum } from '../utils/data';

const VOWELS = ['أ','ا','إ','آ','ء','و','ي','ى','ه','ة'];

function getLetterVal(ch) { return JMML[ch] || 0; }

function tension(a, b) {
  if (a===b) return {label:'تطابق تام ✦',color:C.green,note:'طاقتاك متناسقتان تماماً — ما تُظهره هو ما تشعر به فعلاً'};
  if ((a+b)===10||Math.abs(a-b)===0) return {label:'توافق قوي',color:C.green,note:'الرقمان يكملان بعضهما'};
  if (Math.abs(a-b)<=2) return {label:'توافق جيد',color:C.gold,note:'بينهما احتكاك خفيف لكنه بنّاء'};
  return {label:'توتر خلّاق',color:'#c09050',note:'هذا التناقض هو مصدر نموك الأعمق'};
}

export default function MapScreen() {
  const [name, setName] = useState('');
  const [day, setDay] = useState(''); const [mon, setMon] = useState(''); const [yr, setYr] = useState('');
  const [result, setResult] = useState(null);

  function build() {
    if (!name.trim()||!day||!mon||!yr) { alert('أدخل الاسم الكامل وتاريخ الميلاد'); return; }
    const lifePath = calcRoot(parseInt(day),parseInt(mon),parseInt(yr));
    let nameTotal=0,consTotal=0,soulTotal=0;
    let breakdown=[];
    for(const ch of name){
      const v=getLetterVal(ch);
      if(v>0){nameTotal+=v;breakdown.push({ch,v});if(!VOWELS.includes(ch))consTotal+=v;else soulTotal+=v;}
    }
    const nameNum=reduceNum(nameTotal)||1;
    const persNum=reduceNum(consTotal)||lifePath;
    const soulNum=reduceNum(soulTotal)||reduceNum(nameTotal-consTotal)||lifePath;
    setResult({name,lifePath,nameNum,persNum,soulNum,nameTotal,breakdown,lpd:ROOT_DATA[lifePath]||ROOT_DATA[1],nnd:ROOT_DATA[nameNum]||ROOT_DATA[1],prd:ROOT_DATA[persNum]||ROOT_DATA[1],sld:ROOT_DATA[soulNum]||ROOT_DATA[1],t_lp_name:tension(lifePath,nameNum),t_soul_pers:tension(soulNum,persNum),t_lp_soul:tension(lifePath,soulNum)});
  }

  return (
    <div>
      <QuoteBox text="رقم المسار الروحي يكشف لماذا تتصرف كما تتصرف، ورقم الروح يكشف ما تتوق إليه في صمتك" src="جذر الفلك، الجزء الثالث" />
      <Card>
        <CardTitle>🗺 الخريطة الرقمية الكاملة</CardTitle>
        <p style={{fontSize:12,color:C.text2,marginBottom:16,lineHeight:1.7}}>أدخل اسمك الكامل وتاريخ ميلادك للحصول على خريطتك الرقمية الكاملة من 4 أرقام تشرح هويتك العددية بالكامل.</p>
        <div style={{marginBottom:12}}>
          <label style={{display:'block',fontSize:11,color:C.text2,marginBottom:7}}>الاسم الكامل بالعربية (الاسم الأول + اسم الأب + اسم العائلة)</label>
          <FinInput value={name} onChange={e=>setName(e.target.value)} placeholder="مثال: أحمد محمد الحسن..." maxLength={50}/>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{display:'block',fontSize:11,color:C.text2,marginBottom:7}}>تاريخ الميلاد</label>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1.4fr',gap:8}}>
            <FinInput value={day} onChange={e=>setDay(e.target.value)} placeholder="يوم" type="number" min="1" max="31"/>
            <FinInput value={mon} onChange={e=>setMon(e.target.value)} placeholder="شهر" type="number" min="1" max="12"/>
            <FinInput value={yr} onChange={e=>setYr(e.target.value)} placeholder="سنة" type="number" min="1900" max="2020"/>
          </div>
        </div>
        <BtnPrimary onClick={build} style={{marginTop:4}}>✦ احسب خريطتي الرقمية</BtnPrimary>
      </Card>

      {result && (
        <div style={{animation:'fadeUp .35s ease'}}>
          {/* Header */}
          <div style={{background:`linear-gradient(135deg,${C.bg3},${C.bg4})`,border:`1px solid ${C.goldDim}`,borderRadius:18,padding:24,marginBottom:14,textAlign:'center'}}>
            <div style={{fontSize:13,color:C.text2,marginBottom:10}}>خريطة: {result.name}</div>
            <div style={{display:'flex',justifyContent:'center',gap:16,flexWrap:'wrap'}}>
              {[{n:result.lifePath,lbl:'المسار الروحي'},{n:result.nameNum,lbl:'رقم الاسم'},{n:result.persNum,lbl:'الشخصية'},{n:result.soulNum,lbl:'الروح الداخلية'}].map(x=>(
                <div key={x.lbl} style={{textAlign:'center'}}>
                  <div style={{fontFamily:'Amiri,serif',fontSize:42,color:C.gold,textShadow:'0 0 20px rgba(212,168,71,.4)',lineHeight:1}}>{x.n}</div>
                  <div style={{fontSize:10,color:C.text2,marginTop:3,letterSpacing:.3}}>{x.lbl}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Life path */}
          <RCard type="pos" style={{marginBottom:12}}>
            <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8,display:'flex',alignItems:'center',gap:8}}><span style={{fontFamily:'Amiri,serif',fontSize:22}}>{result.lifePath}</span> رقم المسار الروحي <Badge>من تاريخ الميلاد</Badge></div>
            <div style={{fontSize:14,lineHeight:1.75,marginBottom:8}}><strong>{result.lpd.title}</strong><br/>{result.lpd.desc}</div>
            <ul style={{listStyle:'none',padding:0,margin:0,fontSize:12,color:C.text2}}>
              {[['وظيفتك الأصلية',result.lpd.daily_act||result.lpd.desc],['في العلاقات',result.lpd.love],['في المال',result.lpd.money],['في العمل',result.lpd.work],['تحذير الكتاب',result.lpd.warn]].map(([l,v])=>
                <li key={l} style={{paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span><strong style={{color:C.text}}>{l}:</strong> {v}</li>
              )}
            </ul>
          </RCard>

          {/* Name number */}
          <RCard style={{marginBottom:12}}>
            <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8,display:'flex',alignItems:'center',gap:8}}><span style={{fontFamily:'Amiri,serif',fontSize:22}}>{result.nameNum}</span> رقم الاسم <Badge>من جُمَّل الاسم الكامل</Badge></div>
            <div style={{fontSize:14,lineHeight:1.75,marginBottom:8}}><strong>{result.nnd.title}</strong><br/>{result.nnd.desc}</div>
            <div style={{marginTop:8}}>{result.breakdown.map(({ch,v})=><span key={ch+v} style={{display:'inline-block',background:'rgba(212,168,71,.08)',border:`1px solid ${C.border}`,borderRadius:6,padding:'2px 7px',margin:2,fontSize:12}}>{ch}<sup style={{color:C.gold,fontSize:9}}>{v}</sup></span>)}</div>
            <div style={{fontSize:11,color:C.text2,marginTop:6}}>مجموع قيم الحروف: {result.nameTotal} → جذره: {result.nameNum}</div>
            <div style={{fontSize:12,marginTop:6,color:result.t_lp_name.color}}>علاقته بمسارك الروحي ({result.lifePath}): <strong>{result.t_lp_name.label}</strong> — {result.t_lp_name.note}</div>
          </RCard>

          {/* Personality */}
          <RCard style={{marginBottom:12}}>
            <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8,display:'flex',alignItems:'center',gap:8}}><span style={{fontFamily:'Amiri,serif',fontSize:22}}>{result.persNum}</span> رقم الشخصية <Badge>من الحروف الصامتة</Badge></div>
            <div style={{fontSize:14,lineHeight:1.75,marginBottom:8}}><strong>{result.prd.title}</strong><br/>{result.prd.desc}</div>
            <ul style={{listStyle:'none',padding:0,margin:0,fontSize:12,color:C.text2}}>
              <li style={{paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>هذا ما تُقدمه للعالم — قناعك الخارجي الواعي</li>
              <li style={{paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>في العمل يظهر هكذا: {result.prd.work}</li>
              <li style={{paddingRight:14,position:'relative',lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>تحذيره: {result.prd.warn}</li>
            </ul>
          </RCard>

          {/* Soul urge */}
          <RCard type="spi" style={{marginBottom:12}}>
            <div style={{fontSize:12,color:C.purple,fontWeight:600,marginBottom:8,display:'flex',alignItems:'center',gap:8}}><span style={{fontFamily:'Amiri,serif',fontSize:22,color:C.purple}}>{result.soulNum}</span> رقم الروح الداخلية <Badge>من الحروف المتحركة</Badge></div>
            <div style={{fontSize:14,lineHeight:1.75,marginBottom:8}}><strong>{result.sld.title}</strong><br/>{result.sld.desc}</div>
            <ul style={{listStyle:'none',padding:0,margin:0,fontSize:12,color:C.text2}}>
              <li style={{paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>هذا ما تتوق إليه في صمتك</li>
              <li style={{paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>في الحب تحتاج: {result.sld.love}</li>
              <li style={{paddingRight:14,position:'relative',lineHeight:1.6,color:result.t_soul_pers.color}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>علاقته برقم شخصيتك ({result.persNum}): <strong>{result.t_soul_pers.label}</strong> — {result.t_soul_pers.note}</li>
            </ul>
          </RCard>

          {/* Summary */}
          <div style={{background:`linear-gradient(135deg,${C.bg3},${C.bg4})`,border:`1px solid ${C.goldDim}`,borderRadius:14,padding:18,marginBottom:12,textAlign:'center'}}>
            <div style={{fontFamily:'Amiri,serif',fontSize:16,color:C.gold,marginBottom:8}}>✦ قراءة الخريطة الكاملة</div>
            <div style={{fontSize:14,lineHeight:2,textAlign:'right'}}>
              {result.lifePath===result.nameNum&&result.nameNum===result.soulNum
                ? 'أرقامك الثلاثة متطابقة — شخصيتك من الداخل والخارج واحدة. هذا نادر جداً ويعني تناسقاً روحياً عميقاً.'
                : <>مسارك الروحي <strong style={{color:C.gold}}>{result.lifePath}</strong> يحدد وجهتك، لكن اسمك يُشعّ طاقة <strong style={{color:C.gold}}>{result.nameNum}</strong> للعالم، بينما تتوق روحك لـ <strong style={{color:C.gold}}>{result.soulNum}</strong> في الداخل.{result.lifePath!==result.soulNum&&<><br/>التوتر بين مسارك ({result.lifePath}) وروحك ({result.soulNum}): <strong style={{color:result.t_lp_soul.color}}>{result.t_lp_soul.label}</strong> — {result.t_lp_soul.note}</>}</>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
